import React, {Component} from 'react'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
// var data = [
//    {
//       "tender_mode":"others",
//       "sum":1633458.6199999999,
//       "subData":[
//          {
//             "tender_mode":"BHARAT_QR",
//             "sum":230
//          },
//          {
//             "tender_mode":"EMI",
//             "sum":54321.41
//          },
//          {
//             "tender_mode":"EMI_DEBIT",
//             "sum":16148.59
//          },
//          {
//             "tender_mode":"PHONE_PE",
//             "sum":690
//          },
//          {
//             "tender_mode":"RELIANCE_OR_JIO",
//             "sum":47668.84
//          },
//          {
//             "tender_mode":"UPI",
//             "sum":1514399.7799999998
//          }
//       ]
//    },
//    {
//       "tender_mode":"EFT",
//       "sum":30050370.559999995,
//       "subData":[
//
//       ]
//    }
// ]
class PieofPieChart extends Component {
    constructor(props) {
        super(props);
        // this.state={
        //     chartData:[]
        // }
    }

    componentWillUnmount() {
        // if (this.chart) {
        //     this.chart.dispose();
        // }
    }

    componentDidMount() {
        var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;
        let container = am4core.create("chartdiv", am4core.Container);
        container.width = am4core.percent(80);
        container.height = am4core.percent(80);
        container.layout = "horizontal";

        let chart = container.createChild(am4charts.PieChart);
        container.logo.height = -150;
// Add data  [this.props.data]
        chart.data = this.props.data;
        chart.paddingRight = 100;
        chart.paddingLeft = 50;
// or

// Add and configure Series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "sum";
        pieSeries.dataFields.category = "tender_mode";
        pieSeries.slices.template.states.getKey("active").properties.shiftRadius = 0;
        pieSeries.labels.template.fontSize = 9;

//pieSeries.labels.template.text = "{category}\n{value.percent.formatNumber('#.#')}%";

        pieSeries.slices.template.events.on("hit", function (event) {
            return false;
            // selectSlice(event.target.dataItem);
        })

        let chart2 = container.createChild(am4charts.PieChart);
        chart2.width = am4core.percent(25);
        chart2.radius = am4core.percent(70);

// Add and configure Series
        let pieSeries2 = chart2.series.push(new am4charts.PieSeries());
        pieSeries2.dataFields.value = "sum";
        pieSeries2.dataFields.category = "tender_mode";
        pieSeries2.slices.template.states.getKey("active").properties.shiftRadius = 0;
pieSeries2.labels.template.radius = am4core.percent(50);
pieSeries2.labels.template.inside = false;
pieSeries2.labels.template.fill = am4core.color("#000000");
        pieSeries2.labels.template.disabled = false;
        pieSeries2.labels.template.fontSize = 8;
        pieSeries2.ticks.template.disabled = false;
        pieSeries2.alignLabels = true;
        //pieSeries.labels.template.relativeRotation = 90;
        pieSeries2.events.on("positionchanged", updateLines);

        let interfaceColors = new am4core.InterfaceColorSet();

        let line1 = container.createChild(am4core.Line);
        line1.strokeDasharray = "2,2";
        line1.strokeOpacity = 0.5;
        line1.stroke = interfaceColors.getFor("alternativeBackground");
        line1.isMeasured = false;

        let line2 = container.createChild(am4core.Line);
        line2.strokeDasharray = "2,2";
        line2.strokeOpacity = 0.5;
        line2.stroke = interfaceColors.getFor("alternativeBackground");
        line2.isMeasured = false;

        let selectedSlice;
//         chart.exporting.menu = new am4core.ExportMenu()
//         chart.exporting.menu.align = "right";
//         chart.exporting.menu.verticalAlign = "top";
//         chart.exporting.menu.items = [{
//           "label": "<i class='fa fa-download' aria-hidden='true'></i>",
//           "menu": [
//             { "type": "xlsx", "label": "XLSX" },
//             { "type": "csv", "label": "CSV" },
//           ]
//         }];
//         chart.exporting.filePrefix = fileName.replace(/ /g,"_");
        function selectSlice(dataItem) {

            selectedSlice = dataItem.slice;

            let fill = selectedSlice.fill;

            let count = dataItem.dataContext.subData.length;
            pieSeries2.colors.list = [];
            for (var i = 0; i < count; i++) {
                pieSeries2.colors.list.push(fill.brighten(i * 2 / count));
            }

            chart2.data = dataItem.dataContext.subData;
            pieSeries2.appear();

            let middleAngle = selectedSlice.middleAngle;
            let firstAngle = pieSeries.slices.getIndex(0).startAngle;
            let animation = pieSeries.animate([{
                property: "startAngle",
                to: firstAngle - middleAngle
            }, {property: "endAngle", to: firstAngle - middleAngle + 360}], 600, am4core.ease.sinOut);
            animation.events.on("animationprogress", updateLines);

            selectedSlice.events.on("transformed", updateLines);

//  var animation = chart2.animate({property:"dx", from:-container.pixelWidth / 2, to:0}, 2000, am4core.ease.elasticOut)
//  animation.events.on("animationprogress", updateLines)
        }


        function updateLines() {
            if (selectedSlice) {
                let p11 = {
                    x: selectedSlice.radius * am4core.math.cos(selectedSlice.startAngle),
                    y: selectedSlice.radius * am4core.math.sin(selectedSlice.startAngle)
                };
                let p12 = {
                    x: selectedSlice.radius * am4core.math.cos(selectedSlice.startAngle + selectedSlice.arc),
                    y: selectedSlice.radius * am4core.math.sin(selectedSlice.startAngle + selectedSlice.arc)
                };

                p11 = am4core.utils.spritePointToSvg(p11, selectedSlice);
                p12 = am4core.utils.spritePointToSvg(p12, selectedSlice);

                let p21 = {x: 0, y: -pieSeries2.pixelRadius};
                let p22 = {x: 0, y: pieSeries2.pixelRadius};

                p21 = am4core.utils.spritePointToSvg(p21, pieSeries2);
                p22 = am4core.utils.spritePointToSvg(p22, pieSeries2);

                line1.x1 = p11.x;
                line1.x2 = p21.x;
                line1.y1 = p11.y;
                line1.y2 = p21.y;

                line2.x1 = p12.x;
                line2.x2 = p22.x;
                line2.y1 = p12.y;
                line2.y2 = p22.y;
            }
        }

        chart.events.on("datavalidated", function () {
            setTimeout(function () {
                selectSlice(pieSeries.dataItems.getIndex(0));
            }, 1000);
        });
    }

    render() {
        return (
            <div class="pie_of_pie">
                <div id="chartdiv" style={{width: "100%", height: "250px"}}></div>
            </div>
        )
    }
}

export default PieofPieChart;